import { render } from "./mjs.vue?vue&type=template&id=789e0770"
import script from "./mjs.vue?vue&type=script&lang=js"
export * from "./mjs.vue?vue&type=script&lang=js"

import "./mjs.vue?vue&type=style&index=0&id=789e0770&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__